import { useDiagnosticsStore } from '@/store/useDiagnosticsStore';

export function SavedDataTab() {
  const { savedBaselines, savedMeasurements, removeBaseline, removeMeasurement } =
    useDiagnosticsStore();

  return (
    <div className="space-y-6">
      {/* Saved Baselines */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
          <span className="text-2xl">📦</span>
          Saved Baselines
        </h2>

        {savedBaselines.length === 0 ? (
          <p className="text-gray-500 dark:text-gray-400 text-sm">
            No saved baselines yet. Create one in the Pipeline Test tab.
          </p>
        ) : (
          <div className="space-y-3">
            {savedBaselines.map((baseline) => (
              <div
                key={baseline.id}
                className="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-700 rounded border border-gray-200 dark:border-gray-600"
              >
                <div className="flex-1">
                  <p className="font-medium text-gray-900 dark:text-white">{baseline.name}</p>
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    {baseline.data.frequency_Hz.length} frequency points
                  </p>
                </div>
                <button
                  onClick={() => removeBaseline(baseline.id)}
                  className="px-3 py-1 text-sm bg-red-600 hover:bg-red-700 text-white rounded transition-colors"
                >
                  Delete
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Saved Measurements */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
          <span className="text-2xl">📊</span>
          Saved Measurements
        </h2>

        {savedMeasurements.length === 0 ? (
          <p className="text-gray-500 dark:text-gray-400 text-sm">
            No saved measurements yet. Create one in the Pipeline Test tab.
          </p>
        ) : (
          <div className="space-y-3">
            {savedMeasurements.map((measurement) => (
              <div
                key={measurement.id}
                className="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-700 rounded border border-gray-200 dark:border-gray-600"
              >
                <div className="flex-1">
                  <p className="font-medium text-gray-900 dark:text-white">{measurement.name}</p>
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    {measurement.data.frequency_Hz.length} frequency points
                  </p>
                </div>
                <button
                  onClick={() => removeMeasurement(measurement.id)}
                  className="px-3 py-1 text-sm bg-red-600 hover:bg-red-700 text-white rounded transition-colors"
                >
                  Delete
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Bulk Actions */}
      {(savedBaselines.length > 0 || savedMeasurements.length > 0) && (
        <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-6 border border-gray-200 dark:border-gray-700">
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
            Bulk actions for test data management:
          </p>
          <div className="flex gap-3">
            {savedBaselines.length > 0 && (
              <button
                onClick={() => {
                  if (confirm('Clear all saved baselines? This cannot be undone.')) {
                    savedBaselines.forEach((b) => removeBaseline(b.id));
                    alert('All baselines cleared');
                  }
                }}
                className="px-4 py-2 text-sm bg-red-600 hover:bg-red-700 text-white rounded transition-colors"
              >
                Clear All Baselines
              </button>
            )}
            {savedMeasurements.length > 0 && (
              <button
                onClick={() => {
                  if (confirm('Clear all saved measurements? This cannot be undone.')) {
                    savedMeasurements.forEach((m) => removeMeasurement(m.id));
                    alert('All measurements cleared');
                  }
                }}
                className="px-4 py-2 text-sm bg-red-600 hover:bg-red-700 text-white rounded transition-colors"
              >
                Clear All Measurements
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
